import Hero from "../../components/Hero";
import HeroImage from "../../../assets/images/Blogs1.jpg";

const Blog9 = () => {
  return (
    <div className="home-page">
      <Hero
        title="Blogs"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="white-container">
        <div className="white-container-content" style={{ gap: "25px" }}>
          <div className="content-semibold burgandy">
            Unveiling Conditional Selling: A Wake-Up Call for the UK Property
            Market
          </div>
          <div className="content burgandy">Jul 17, 2025</div>
          <div className="divider burgandy" />
          <div className="content grey align-left">
            A recent undercover investigation by <strong>BBC Panorama</strong>{" "}
            has shed light on concerning practices within the UK estate agency
            sector. The investigation revealed instances of{" "}
            <strong>“conditional selling,”</strong> where estate agents
            allegedly prioritise buyers who commit to using in-house services
            like mortgages and conveyancing, potentially sidelining higher
            offers from independent buyers.
          </div>

          <div className="content grey align-left">
            <strong>
              Your home may be repossessed if you do not keep up repayments on
              your mortgage
            </strong>
          </div>

          <div className="content grey align-left">
            Information correct as of 17 July 2024
          </div>

          <div className="content grey align-left">
            <strong>Disclaimer:</strong> This blog post provides general
            information and should not be construed as financial advice. For
            personalised guidance, please consult with a qualified financial
            advisor.
          </div>

          <div
            className="content-semibold grey align-left"
            style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}
          >
            What Is Conditional Selling?
            <div
              style={{
                borderBottom: "3px solid var(--burgandy)",
                width: "100%",
                margin: "10px 0",
              }}
            ></div>
          </div>

          <div className="content grey align-left">
            Conditional selling occurs when estate agents suggest or imply that
            prospective buyers must use their in-house services to have their
            offers considered. This practice can lead to situations where buyers
            who are willing to pay more for a property are overlooked in favour
            of those who agree to use additional services, potentially
            compromising the seller’s financial outcome.
          </div>

          <div
            className="content-semibold grey align-left"
            style={{ fontSize: "1.7rem", marginTop: "2rem" }}
          >
            The Panorama Investigation: Key Findings
          </div>

          <div className="content grey align-left">
            <ul style={{ paddingLeft: "22px", marginTop: "1rem" }}>
              <li style={{ marginBottom: "1rem" }}>
                <strong>Estate Agency A:</strong> Undercover footage captured a
                senior branch manager expressing a preference for buyers who had
                agreed to use the company’s mortgage and conveyancing services,
                referring to them as “hot buyers.” This approach seemingly
                influenced the handling of offers, with some prospective buyers
                being sidelined if they did not commit to these in-house
                services.
              </li>
              <li>
                <strong>Estate Agency B:</strong> A whistleblower revealed that
                staff were incentivised to encourage sellers to reduce property
                prices, sometimes after overvaluing them initially to attract
                listings. Additionally, there were reports of pressure on buyers
                to use the company’s conveyancing services, with staff allegedly
                stating that they were “by far and away very expensive,”
                discouraging comparison shopping.
              </li>
            </ul>
          </div>

          <div
            className="content grey align-left"
            style={{
              background: "#f2f2f2",
              padding: "1.5rem",
              marginTop: "2rem",
              borderRadius: "8px",
              boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
            }}
          >
            <div
              className="content-semibold grey align-left"
              style={{ fontSize: "1.7rem", marginBottom: "1rem" }}
            >
              Industry Response and Calls for Reform
            </div>

            <div className="content grey align-left">
              The revelations have sparked significant concern within the
              property industry. Emily Franks, a mortgage broker, has written to
              her local Member of Parliament urging for stricter regulation of
              estate agencies to prevent conditional selling. She emphasised
              that clients should have the freedom to choose their service
              providers without facing disadvantages in property transactions.
              <br />
              <br />
              Furthermore, Propertymark, the UK’s leading professional body for
              property agents, has acknowledged the need for stronger consumer
              protections and is reviewing industry standards to ensure they
              remain effective.
            </div>
          </div>

          <div
            className="content-semibold grey align-left"
            style={{ fontSize: "1.7rem", marginTop: "2rem" }}
          >
            Implications for the Financial Services Sector
          </div>

          <div className="content grey align-left">
            For financial services firms, these developments underscore the
            importance of transparency and ethical practices in property
            transactions. The scrutiny of estate agents’ in-house services
            highlights potential conflicts of interest that could impact
            consumer trust. Financial institutions should consider reinforcing
            their commitment to impartial advice and exploring partnerships that
            prioritise the best interests of clients.
          </div>

          <div
            className="content-semibold grey align-left"
            style={{ fontSize: "1.7rem", marginTop: "2rem" }}
          >
            Moving Forward: A Call for Ethical Practices
          </div>

          <div className="content grey align-left">
            The Panorama investigation serves as a critical reminder of the need
            for integrity and fairness in the property market. As the industry
            moves forward, it is essential to foster an environment where buyers
            and sellers can make informed decisions without undue pressure or
            conflicts of interest. By upholding ethical standards, the property
            sector can rebuild consumer confidence and ensure that the interests
            of all parties are respected.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog9;
